import { buildNavigationUrl } from "../../util/buildNavigationUrl";
const buildShipmentNavigationTargetUrl = ({
  activeSubPage = "details",
  recordId,
  status = "all",
}) => {
  const query = new URLSearchParams(
    status && status !== "all" ? { status } : {},
  );

  return buildNavigationUrl(
    `/shipments/${recordId}/${activeSubPage || "details"}`,
    query,
  );
};

export { buildShipmentNavigationTargetUrl };
